var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _vm._m(0),
    _c("div", { staticClass: "content" }, [_c("router-view")], 1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "leftMenu" }, [
      _c("div", { staticClass: "moduleTitle" }, [_vm._v("印刷厂工作台")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }